import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { ALLOWED_EMAIL_DOMAIN } from "../lib/constants";

export function AuthGuard({ children, requireAdmin }: { children: React.ReactNode; requireAdmin?: boolean }) {
  const { session, profile, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground text-sm">Ładowanie…</div>
      </div>
    );
  }
  if (!session) return <Navigate to="/crm/login" state={{ from: loc.pathname }} replace />;

  const email = session.user?.email || "";
  if (!email.toLowerCase().endsWith(`@${ALLOWED_EMAIL_DOMAIN}`)) {
    return <Navigate to="/crm/login?error=domain" replace />;
  }
  if (!profile) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground text-sm">Tworzenie profilu…</div>
      </div>
    );
  }
  if (requireAdmin && profile.role !== "admin") {
    return <Navigate to="/crm" replace />;
  }
  return <>{children}</>;
}
